import React, { useEffect, useRef } from "react";
import "../../styles/animatica.css";
import Navbar from "../common/Navbar";

const splitWords = (text, extraClass = "") =>
  text.split(" ").map((word, index) => (
    <span
      key={index}
      className={`an-word${extraClass ? " " + extraClass : ""}`}
      style={{ transitionDelay: `${0.2 + index * 0.05}s` }}
    >
      {word}&nbsp;
    </span>
  ));

const HkiAnimaticaHero = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          element.classList.add("an-visible");
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={sectionRef}
      className="d-flex flex-column min-vh-100 animaticahero_bg an-hero"
    >
      <div className="an-hero-scrim" />
      <div className="an-hero-divider" />
      <Navbar transparent />
      <div className="container py-5 d-flex flex-grow-1 flex-column justify-content-md-end justify-content-center mb-md-5 align-items-center">
        <div className="text-center" style={{ maxWidth: "900px" }}>
          <span className="an-reveal an-reveal-d1 an-hero-badge">
            <span className="an-hero-badge-dot" />
            Skilling &amp; Franchise Network
          </span>
          <h1 className="an-hero-title ff_s mb-0 mt-4 text-white">
            {splitWords("Welcome to")}{" "}
            <span className="an-word text-white" style={{ transitionDelay: "0.35s" }}>
              ICASA
            </span>
          </h1>
          <div className="an-reveal an-reveal-d3 an-divider mx-auto" />
          <p className="an-reveal an-reveal-d4 fs_24 fw-semibold ff_n text-white mt-3 mb-0">
            "Revolutionizing Media &amp; Entertainment Education
            <br className="d-md-block d-none" /> with Industry-Led Training
            and In-House Content Creation"
          </p>
        </div>
      </div>
      <div className="an-scroll-cue">
        <span className="an-scroll-cue-line" />
        Scroll
      </div>
    </div>
  );
};

export default HkiAnimaticaHero;
